import { Box, Typography } from '@mui/material'
import i18n from 'i18n'
import { ReactNode } from 'react'
import { theme } from 'theme'

interface TitleWithIconRowProps {
  icon: ReactNode
  title: string
}

export default function TitleWithIconRow(props: TitleWithIconRowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center'
      }}
    >
      {props.icon}
      <Typography
        sx={{
          transform: `translateY(${1}px)`,
          marginLeft: i18n.dir() === 'ltr' ? 1 : undefined,
          marginRight: i18n.dir() === 'rtl' ? 1 : undefined,
          fontSize: '13px',
          fontWeight: 300
        }}
        fontSize={14}
      >
        {props.title}
      </Typography>
    </Box>
  )
}
